module.exports = __webpack_public_path__ + "img/1.2.1数据科学家.b6687dc7.png";